"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _View = _interopRequireDefault(require("react-native-web/dist/exports/View"));

var _quarkWeb = require("quark-web");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// needs to be a class to hold references
var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this.state = {
      active: false,
      index: -1
    }, _this._toggleDropdown = function () {
      return _this.setState({
        active: !_this.state.active,
        index: -1
      });
    }, _this._content = function (dimensions) {
      return React.createElement(_quarkWeb.ClickAway, {
        active: _this.state.active,
        onClick: _this._toggleDropdown,
        filter: function filter(evt) {
          return _this._toggle ? !_this._toggle.contains(evt.target) : false;
        }
      }, React.createElement(_quarkWeb.Card, {
        style: _extends({}, _styles.default.dropdown, {
          position: 'fixed',
          left: dimensions.left,
          width: dimensions.width,
          top: dimensions.top + dimensions.height
        }, _this.props.dropdownStyle)
      }, _this.props.children({
        index: _this.state.index,
        setIndex: function setIndex(index) {
          return _this.setState({
            index: index
          });
        },
        toggle: _this._toggleDropdown
      })));
    }, _this._keyDown = function (event) {
      // if the user pressed ↑
      // disable-flow
      if (event.which === 38) {
        event.preventDefault(); // increment the counter

        _this.setState({
          // make sure we're always over the minimum
          index: Math.max(_this.state.index - 1, _this.props.min || 0)
        }); // otherwise if the user pressed ↓

      } else if (event.which === 40) {
        event.preventDefault(); // decrement the counter

        _this.setState({
          // make sure we're always under the maximum value
          index: Math.min(_this.state.index + 1, (_this.props.max || Infinity) - 1)
        });
      }
    }, _temp));
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return [React.createElement(_quarkWeb.Measure, null, function (_ref2) {
        var measureRef = _ref2.measureRef,
            dimensions = _objectWithoutProperties(_ref2, ["measureRef"]);

        return React.createElement(_View.default, {
          style: _extends({}, _styles.default.anchor, _this2.props.style)
        }, React.createElement("div", {
          onClick: _this2._toggleDropdown,
          ref: function ref(ele) {
            _this2._toggle = ele;
            measureRef(ele);
          },
          style: _styles.default.toggle
        }, _this2.props.toggle), _this2.state.active && React.createElement(_quarkWeb.Portal, {
          id: "dropdown"
        }, _this2._content(dimensions)));
      }), this.state.active && React.createElement(_quarkWeb.EventListener, {
        event: "keydown",
        key: "events"
      }, this._keyDown)];
    }
  }]);

  return Dropdown;
}(React.Component);

var _default = Dropdown;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/form/Dropdown/index.js
// module id = ./node_modules/quark-web/components/form/Dropdown/index.js
// module chunks = 0